import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import videoShow from "../../assets/image/get.mp4";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function GetInTouch() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <section className="relative">
            {/* <img className="d-none absolute w-[150px] h-[150px] -top-[100px] left-[63px]" src={require("../../assets/image/get.svg").default} alt="" /> */}
            <div className="m-10-res f-col container flex justify-center gap-[40px] items-cetner p-[40px] bg-[#0B2C3D] rounded-[8px]">
                <div className="w-100 w-[35%] flex flex-col justify-center gap-[12px]">
                    <div className="js-scroll fade-top text-[#B39359] capitalize text-[16px]">{t("get in touch")}</div>
                    <div className="js-scroll fade-top text-white font-bold text-[23px]">{t("Discover Your Dream Home Today - Start Your Journey with Ligasos")}</div>
                    <Link to={"/contact"} className="js-scroll fade-top flex items-center gap-[7px] bg-[#B39359] w-fit capitalize py-[8px] px-[30px] rounded-[4px] font-bold text-white">
                        {t("Contact us")}
                        <img
                            src={require("../../assets/icons/arrow-button.svg").default}
                            alt=""
                            className="w-[15px] h-[15px]"
                        />
                    </Link>
                </div>
                <div className="js-scroll fade-top w-100 w-[60%] relative overflow-hidden">
                    <video
                        className="w-full h-auto rounded-lg shadow-md"
                        controls
                        aria-label="Sample video demonstrating professional integration"
                        src={videoShow} type="video/mp4"
                    >
                    </video>
                </div>
            </div>
        </section >
    );
}